/** @jsx jsx */
import {jsx} from 'theme-ui'
import Loader from './Loader'
import {useTranslation} from 'react-i18next'

type Props = {}

const FixedLoader: React.FC<Props> = () => {
  const {t} = useTranslation()
  return (
    <div
      sx={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, .3)',
        zIndex: 100,
      }}
    >
      <div
        sx={{
          position: 'absolute',
          top: '50%',
          right: '50%',
          transform: 'translate(50%, -50%)',
          backgroundColor: '#fff',
          width: 400,
          height: 300,
          px: 20,
          py: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',

          borderRadius: 16,
          flexDirection: 'column',
          zIndex: 100,
        }}
      >
        <h2>{t('loadingMessage')}</h2>
        <div>
          <Loader />
        </div>
      </div>
    </div>
  )
}

export default FixedLoader
